<div style="width: 100%; height: 100%; overflow: hidden;">
    <img src="assets/img/photo3.jpg" alt="UniSurvey" style="object-fit: cover; width: 100%;"/>
</div>
